import { useSharedAPI } from "@certn/api";
import { useMemo } from "react";

import { SearchableSelectControl } from "./SearchableSelectControl";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

const NATIONALITY_LABEL_OVERRIDES: Record<string, string> = {
  GB: "United Kingdom (British)",
};

export function NationalitySelectControl(props: CascadiaControlProps) {
  const { data: countryList, isLoading } = useSharedAPI(
    "/api/internal/shared/countries/"
  );

  const sortedCountryList = useMemo(
    () => countryList?.sort((a, b) => a.name.localeCompare(b.name)),
    [countryList]
  );

  const mappedCountryList = useMemo(
    () =>
      sortedCountryList?.map((country) => ({
        label: NATIONALITY_LABEL_OVERRIDES[country.alpha_2] ?? country.name,
        value: country.alpha_2,
      })),
    [sortedCountryList]
  );

  return (
    <SearchableSelectControl
      {...props}
      items={mappedCountryList || []}
      required={Boolean(sortedCountryList?.length && props.required)}
      isLoading={isLoading}
    />
  );
}

NationalitySelectControl.displayName = "NationalitySelectControl";

export const NationalitySelectRenderer = withCascadiaControlProps(
  NationalitySelectControl
);
